export const categories = [
  { id: "all", name: "全部", slug: "all" },
  { id: "hot-blooded", name: "热血", slug: "hot-blooded" },
  { id: "romance", name: "恋爱", slug: "romance" },
  { id: "fantasy", name: "奇幻", slug: "fantasy" },
  { id: "comedy", name: "搞笑", slug: "comedy" },
  { id: "action", name: "动作", slug: "action" },
  { id: "horror", name: "悬疑", slug: "horror" },
  { id: "slice-of-life", name: "日常", slug: "slice-of-life" },
  { id: "scifi", name: "科幻", slug: "scifi" },
  { id: "school", name: "校园", slug: "school" },
  { id: "adventure", name: "冒险", slug: "adventure" },
  { id: "martial", name: "武侠", slug: "martial" },
];

export const comics = [
  {
    id: 1,
    slug: "sword-legend",
    title: "剑道传说",
    author: "林风眠",
    cover: "https://readdy.ai/api/search-image?query=A%20stunning%20manga-style%20illustration%20of%20a%20young%20swordsman%20with%20flowing%20dark%20hair%20holding%20a%20gleaming%20katana%20under%20cherry%20blossom%20trees%20at%20sunset%20warm%20golden%20light%20dramatic%20composition%20vibrant%20colors%20clean%20anime%20art%20style%20high%20detail&width=800&height=1066&seq=comic-cover-01&orientation=portrait",
    category: "martial",
    description: "少年林风自幼习剑，为报父仇踏入江湖。在机缘巧合下获得上古剑谱，从此踏上剑道巅峰之路。一路上结识众多豪杰，经历生死考验，最终成长为一代剑神。",
    rating: 9.5,
    views: 1258000,
    status: "连载中",
    updatedAt: "2026-08-03",
    chapters: 156,
    tags: ["武侠", "热血", "江湖"],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    slug: "star-sea",
    title: "星辰大海",
    author: "墨染青衫",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20illustration%20of%20a%20girl%20astronaut%20floating%20in%20colorful%20nebula%20space%20with%20stars%20and%20galaxies%20surrounding%20her%20ethereal%20dreamy%20atmosphere%20soft%20pastel%20colors%20sci-fi%20manga%20art%20style%20high%20quality&width=800&height=1066&seq=comic-cover-02&orientation=portrait",
    category: "scifi",
    description: "公元3026年，人类已经进入星际时代。少女星瑶意外获得一艘神秘飞船，与同伴们一起踏上探索未知星域的冒险旅程。浩瀚宇宙中隐藏着无数秘密等待他们去发现。",
    rating: 9.3,
    views: 980000,
    status: "连载中",
    updatedAt: "2026-08-02",
    chapters: 89,
    tags: ["科幻", "冒险", "星际"],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    slug: "sweet-dream",
    title: "甜蜜梦境",
    author: "樱花落",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20anime%20illustration%20of%20a%20schoolgirl%20and%20schoolboy%20sharing%20earphones%20under%20a%20cherry%20blossom%20tree%20pink%20petals%20falling%20soft%20sunlight%20warm%20and%20gentle%20atmosphere%20shojo%20manga%20style%20high%20quality&width=800&height=1066&seq=comic-cover-03&orientation=portrait",
    category: "romance",
    description: "高中生苏甜是一个普通到不能再普通的女孩，直到有一天校草江辰突然向她表白。原来两人的缘分早已在梦中注定。从校园到社会，一段甜蜜又温暖的爱情故事。",
    rating: 9.6,
    views: 2300000,
    status: "已完结",
    updatedAt: "2026-07-15",
    chapters: 200,
    tags: ["恋爱", "校园", "甜宠"],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    slug: "dragon-realm",
    title: "龙域争霸",
    author: "夜行者",
    cover: "https://readdy.ai/api/search-image?query=An%20epic%20anime%20illustration%20of%20a%20warrior%20riding%20a%20massive%20dragon%20in%20a%20fantasy%20world%20with%20floating%20islands%20and%20magical%20energy%20auras%20dramatic%20lighting%20fiery%20background%20adventure%20manga%20style%20high%20detail&width=800&height=1066&seq=comic-cover-04&orientation=portrait",
    category: "fantasy",
    description: "龙域大陆上，少年龙晨觉醒上古龙族血脉，被卷入一场席卷整个大陆的争霸之战。与伙伴们共同成长，一步步揭开龙域世界的神秘面纱。",
    rating: 9.4,
    views: 1850000,
    status: "连载中",
    updatedAt: "2026-08-04",
    chapters: 210,
    tags: ["奇幻", "冒险", "龙族"],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 5,
    slug: "laugh-king",
    title: "搞笑大王",
    author: "不笑算我输",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20and%20colorful%20anime%20illustration%20of%20a%20chibi%20character%20with%20exaggerated%20facial%20expressions%20making%20silly%20faces%20bright%20vibrant%20colors%20cartoonish%20comedy%20manga%20style%20playful%20energetic%20high%20quality&width=800&height=1066&seq=comic-cover-05&orientation=portrait",
    category: "comedy",
    description: "一个倒霉蛋的日常搞笑生活！从上学迟到到约会翻车，每一话都让你笑出腹肌。没有最搞笑，只有更搞笑！",
    rating: 9.2,
    views: 3200000,
    status: "连载中",
    updatedAt: "2026-08-03",
    chapters: 180,
    tags: ["搞笑", "日常", "轻松"],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 6,
    slug: "shadow-hunter",
    title: "暗影猎手",
    author: "暗夜之瞳",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20mysterious%20anime%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%20at%20night%20with%20neon%20reflections%20noir%20atmosphere%20suspense%20thriller%20manga%20style%20dramatic%20shadows%20high%20quality&width=800&height=1066&seq=comic-cover-06&orientation=portrait",
    category: "horror",
    description: "城市中接连发生离奇案件，私家侦探莫辰被卷入其中。随着调查深入，他发现这些案件背后隐藏着一个惊天秘密。悬疑推理，步步惊心！",
    rating: 9.1,
    views: 760000,
    status: "连载中",
    updatedAt: "2026-08-01",
    chapters: 67,
    tags: ["悬疑", "推理", "都市"],
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 7,
    slug: "campus-diary",
    title: "校园日记",
    author: "四月天",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20slice-of-life%20anime%20illustration%20of%20high%20school%20students%20chatting%20and%20laughing%20in%20a%20sunlit%20classroom%20with%20desks%20and%20windows%20showing%20blue%20sky%20gentle%20atmosphere%20school%20life%20manga%20style%20bright%20and%20cheerful&width=800&height=1066&seq=comic-cover-07&orientation=portrait",
    category: "school",
    description: "高一新生林小沐进入梦想中的高中，结识了一群性格各异的朋友。三年的高中生活，有欢笑、有泪水、有感动，记录下青春最美的模样。",
    rating: 9.0,
    views: 1500000,
    status: "已完结",
    updatedAt: "2026-06-20",
    chapters: 120,
    tags: ["校园", "青春", "友情"],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 8,
    slug: "flame-hero",
    title: "烈焰英雄",
    author: "火之意志",
    cover: "https://readdy.ai/api/search-image?query=An%20action-packed%20anime%20illustration%20of%20a%20firefighter%20hero%20with%20flames%20surrounding%20him%20dynamic%20pose%20intense%20expression%20orange%20and%20red%20color%20palette%20shonen%20manga%20style%20explosive%20energy%20high%20detail&width=800&height=1066&seq=comic-cover-08&orientation=portrait",
    category: "hot-blooded",
    description: "普通高中生楚炎在一次火灾事故中觉醒异能，从此走上守护城市的英雄之路。热血战斗，友情羁绊，永不言弃的精神！",
    rating: 9.5,
    views: 2100000,
    status: "连载中",
    updatedAt: "2026-08-04",
    chapters: 245,
    tags: ["热血", "异能", "英雄"],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 9,
    slug: "cat-coffee",
    title: "猫咪咖啡馆",
    author: "软糖不甜",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20heartwarming%20anime%20illustration%20of%20a%20girl%20working%20in%20a%20cat%20cafe%20surrounded%20by%20cute%20fluffy%20cats%20warm%20coffee%20shop%20interior%20soft%20lighting%20pastel%20colors%20slice-of-life%20manga%20style%20peaceful%20atmosphere&width=800&height=1066&seq=comic-cover-09&orientation=portrait",
    category: "slice-of-life",
    description: "辞掉996工作的白小喵，在街角开了一家猫咪咖啡馆。每天与可爱的猫咪和温暖的故事相伴，治愈自己也治愈每一个来访的客人。",
    rating: 9.3,
    views: 680000,
    status: "连载中",
    updatedAt: "2026-08-02",
    chapters: 78,
    tags: ["日常", "治愈", "猫咪"],
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 10,
    slug: "ocean-heart",
    title: "深海之心",
    author: "蓝鲸之梦",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20anime%20illustration%20of%20a%20mermaid%20princess%20swimming%20in%20a%20magical%20underwater%20kingdom%20with%20coral%20reefs%20and%20bioluminescent%20creatures%20ethereal%20blue%20and%20teal%20colors%20dreamy%20atmosphere%20adventure%20manga%20style&width=800&height=1066&seq=comic-cover-10&orientation=portrait",
    category: "adventure",
    description: "人鱼公主海心的冒险故事！为了拯救被污染的海洋王国，她勇敢地踏上寻找传说中海神之心的旅程。一路上海洋奇观令人叹为观止。",
    rating: 9.4,
    views: 1120000,
    status: "连载中",
    updatedAt: "2026-08-03",
    chapters: 95,
    tags: ["冒险", "奇幻", "海洋"],
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 11,
    slug: "blade-dancer",
    title: "刀锋舞者",
    author: "铁血丹心",
    cover: "https://readdy.ai/api/search-image?query=An%20intense%20action%20anime%20illustration%20of%20a%20female%20warrior%20dual-wielding%20blades%20in%20mid-air%20combat%20pose%20with%20sakura%20petals%20flying%20around%20dynamic%20movement%20samurai%20aesthetic%20action%20manga%20style%20sharp%20detail&width=800&height=1066&seq=comic-cover-11&orientation=portrait",
    category: "action",
    description: "女武者柳如烟为保护家园挺身而出，凭借精湛刀法与邪恶势力正面交锋。刀光剑影中尽显巾帼不让须眉的豪迈气概！",
    rating: 9.2,
    views: 890000,
    status: "已完结",
    updatedAt: "2026-05-30",
    chapters: 168,
    tags: ["动作", "武侠", "女性主角"],
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 12,
    slug: "magic-academy",
    title: "魔法学院",
    author: "星辰魔法师",
    cover: "https://readdy.ai/api/search-image?query=A%20magical%20anime%20illustration%20of%20students%20casting%20spells%20in%20a%20grand%20wizard%20academy%20with%20floating%20books%20and%20magical%20circles%20colorful%20magic%20effects%20Hogwarts-like%20but%20anime%20style%20fantasy%20school%20setting%20high%20quality&width=800&height=1066&seq=comic-cover-12&orientation=portrait",
    category: "fantasy",
    description: "平凡的少年陆明意外收到魔法学院的录取通知书，从此打开了新世界的大门。在魔法学院中学习、成长、结识挚友，一步步揭开自己的身世之谜。",
    rating: 9.3,
    views: 1680000,
    status: "连载中",
    updatedAt: "2026-08-04",
    chapters: 132,
    tags: ["奇幻", "学院", "魔法"],
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
];

export const faqs = [
  {
    question: "香香漫画是否完全免费？",
    answer: "是的，香香漫画平台上的所有漫画资源均为免费阅读。我们致力于为广大漫画爱好者提供优质的免费阅读服务，无需支付任何费用即可畅享海量漫画内容。",
  },
  {
    question: "香香漫画支持哪些设备阅读？",
    answer: "香香漫画支持在电脑、平板和手机等多种设备上阅读。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸，无论您使用什么设备都能获得良好的阅读体验。",
  },
  {
    question: "香香漫画多久更新一次？",
    answer: "香香漫画的连载作品更新频率因作品而异，热门漫画通常每周更新1-3话。您可以在每部漫画的详情页查看具体的更新时间安排，也可以关注我们的首页获取最新更新信息。",
  },
  {
    question: "如何在香香漫画上找到喜欢的漫画？",
    answer: "您可以通过首页的分类导航浏览不同题材的漫画，也可以使用搜索功能直接查找感兴趣的作品。我们还会在首页推荐热门漫画和新上架作品，帮助您发现更多精彩内容。",
  },
  {
    question: "香香漫画的下拉式阅读是什么？",
    answer: "下拉式阅读是香香漫画的特色功能，您只需向下滑动页面即可连续阅读漫画章节，无需频繁点击翻页按钮。这种流畅的阅读方式让追更变得更加轻松愉快。",
  },
];

export const testimonials = [
  {
    name: "小明",
    avatar: "https://readdy.ai/api/search-image?query=A%20friendly%20anime-style%20boy%20avatar%20with%20short%20black%20hair%20and%20warm%20smile%20simple%20clean%20illustration%20on%20light%20background&width=200&height=200&seq=avatar-01&orientation=squarish",
    comment: "香香漫画真的太棒了！漫画资源超级全，更新速度也快，每天必刷的漫画网站。",
    rating: 5,
  },
  {
    name: "小雨",
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime-style%20girl%20avatar%20with%20long%20pink%20hair%20and%20gentle%20smile%20simple%20clean%20illustration%20on%20light%20background&width=200&height=200&seq=avatar-02&orientation=squarish",
    comment: "下拉式阅读体验简直无敌，再也不用一页一页地点了，追更效率翻倍！",
    rating: 5,
  },
  {
    name: "阿杰",
    avatar: "https://readdy.ai/api/search-image?query=An%20anime-style%20boy%20avatar%20with%20spiky%20brown%20hair%20and%20confident%20expression%20simple%20clean%20illustration%20on%20light%20background&width=200&height=200&seq=avatar-03&orientation=squarish",
    comment: "免费而且质量高，分类也很清晰，找漫特别方便。已经推荐给很多朋友了！",
    rating: 5,
  },
  {
    name: "小月",
    avatar: "https://readdy.ai/api/search-image?query=An%20anime-style%20girl%20avatar%20with%20short%20blue%20hair%20and%20shy%20smile%20simple%20clean%20illustration%20on%20light%20background&width=200&height=200&seq=avatar-04&orientation=squarish",
    comment: "从学生时代就在用香香漫画，现在工作了还是离不开。感谢平台提供了这么多好看的漫画！",
    rating: 5,
  },
];

export const siteInfo = {
  name: "香香漫画",
  description: "香香漫画是一个专注于提供免费漫画阅读的在线平台。我们致力于为广大漫画爱好者提供海量高清漫画资源，支持下拉式阅读体验，让追更变得更加轻松愉快。",
  founded: "2019年",
  totalComics: "5000+",
  totalUsers: "800万+",
  dailyActive: "50万+",
  email: "contact@xiangxiangmanga.com",
  address: "中国广东省广州市天河区",
  wechat: "xiangxiangmanga",
  qq: "1234567890",
};